<mat-card>
  <mat-card-header class="d-flex justify-content-between">
    <mat-card-title> Customer </mat-card-title>

    <div class="d-flex align-items-center">
      <div>{{ utils.getStatus(customer.status) }}</div>
      <mat-icon class="ms-2 {{ utils.getStatusColor(customer.status) }}">
        {{ utils.getStatusIcon(customer.status) }}
      </mat-icon>
    </div>
  </mat-card-header>

  <mat-card-content>
    @if ($fetchedAt | async) {

    <div class="img-holder">
      <input
        #fileInput
        type="file"
        (change)="onFileChange($event)"
        accept=".png, .jpg, .jpeg"
      />

      <img [src]="customer.imageUrl" alt="Customer Logo" class="img-fluid" />

      <button mat-icon-button class="icon" (click)="fileInput.click()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>

    <div class="container w-unset">
      <form [formGroup]="form" class="mt-4">
        <mat-form-field class="w-100">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" type="text" />
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>Description</mat-label>
          <textarea
            matInput
            formControlName="description"
            type="text"
          ></textarea>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>API Key</mat-label>
          <input disabled="disabled" matInput [value]="customer.apiKey" />
        </mat-form-field>

        <div class="my-3">
          <div class="mb-2">Operating Hours</div>
          <app-operating-hours
            [operatingHours]="operatingHours"
            (operatingHoursChange)="onOperatingHoursChange($event)"
          />
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4">
          <mat-label>Enable Customer</mat-label>
          <mat-slide-toggle formControlName="enabled" />
        </div>

        @if (error) {
        <app-alert class="mt-3" type="error" (close)="error=null">
          {{ error }}
        </app-alert>
        }

        <div class="d-flex align-items-center justify-content-end mt-4">
          @if (loading) {
          <mat-progress-spinner
            class="me-2"
            mode="indeterminate"
            color="primary"
            diameter="30"
          />
          }

          <div style="display: flex">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              class="px-4"
              [disabled]="loading"
              (click)="onFormSubmit()"
            >
              Save Customer
            </button>
          </div>
        </div>
      </form>
    </div>
    }
    <!---->
    @if (!($fetchedAt | async)) {
    <div class="d-flex justify-content-center">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    }
  </mat-card-content>
</mat-card>
